import React from 'react';
import ModalTemplate from '@component/common/modal/modal-template';
import SubscriptionPlanLaunchModal from '@component/iyagigo/modal/notice-modal/subscription-plan-launch-modal';
import SpeakingAppNoticeModal from '@component/iyagigo/modal/notice-modal/speaking-app-notice-modal';
import { isSpeakingAppNoticeModalDataType, isSubscriptionPlanLaunchModalDataType } from '@datatype/iyagigo/type';
import { dismissNoticeByHour } from '@hook/iyagigo/useNotification';
import { useTypedDispatch, useTypedSelector } from '@hook/common/useStore';
import { actions as modalActions } from '@store/slice/modal-slice';

const NoticeModal: React.FC = () => {
  const dispatch = useTypedDispatch();
  const modalData = useTypedSelector((state) => state.rootReducer?.modalReducer?.noticeModalData) || null;

  const handleClose = () => {
    dismissNoticeByHour();
    dispatch(modalActions.hideModal());
  };

  return (
    <ModalTemplate onClose={handleClose}>
      {isSubscriptionPlanLaunchModalDataType(modalData) && <SubscriptionPlanLaunchModal />}
      {isSpeakingAppNoticeModalDataType(modalData) && <SpeakingAppNoticeModal />}
    </ModalTemplate>
  );
};

export default NoticeModal;
